import React from 'react';
import styled from 'styled-components';
import Button from '../components/common/Button';
import FeatureBlock from '../components/common/FeatureBlock';
import Card from '../components/common/Card';

// Imagens temporárias (serão substituídas por imagens reais)
const solutionsImage = 'https://via.placeholder.com/600x400?text=Solutions';
const cxTeamsImage = 'https://via.placeholder.com/500x300?text=CX+Teams';
const supportAgentsImage = 'https://via.placeholder.com/500x300?text=Support+Agents';
const operationsImage = 'https://via.placeholder.com/500x300?text=Operations';

const SolutionsPage = () => {
  return (
    <div>
      {/* Hero Section */}
      <SolutionsHero>
        <SolutionsHeroContent>
          <SolutionsHeroTitle>Soluções de IA para Experiência do Cliente</SolutionsHeroTitle>
          <SolutionsHeroSubtitle>
            Transforme seu atendimento ao cliente com soluções personalizadas para sua função e indústria
          </SolutionsHeroSubtitle>
          <SolutionsHeroActions>
            <Button size="large">Solicite uma Demo</Button>
            <Button variant="secondary" size="large">Saiba Mais</Button>
          </SolutionsHeroActions>
        </SolutionsHeroContent>
      </SolutionsHero>

      {/* Solutions by Function Section */}
      <Section>
        <SectionTitle>Soluções por Função</SectionTitle>
        <SectionDescription>
          A Leadfy oferece soluções personalizadas para cada função em sua organização, garantindo que todos os membros da equipe tenham as ferramentas certas para o sucesso.
        </SectionDescription>
        
        <SolutionsGrid>
          <SolutionCard>
            <SolutionIcon>👥</SolutionIcon>
            <SolutionTitle>Equipes de CX</SolutionTitle>
            <SolutionDescription>
              Transforme a experiência do cliente com IA que entende, resolve e aprimora cada interação.
            </SolutionDescription>
            <SolutionLink href="/solutions/cx-teams">Saiba mais</SolutionLink>
          </SolutionCard>
          
          <SolutionCard>
            <SolutionIcon>🛠️</SolutionIcon>
            <SolutionTitle>Agentes de Suporte</SolutionTitle>
            <SolutionDescription>
              Capacite seus agentes com ferramentas de IA que aumentam a produtividade e melhoram a satisfação do cliente.
            </SolutionDescription>
            <SolutionLink href="/solutions/support-agents">Saiba mais</SolutionLink>
          </SolutionCard>
          
          <SolutionCard>
            <SolutionIcon>📊</SolutionIcon>
            <SolutionTitle>Operações</SolutionTitle>
            <SolutionDescription>
              Otimize processos e fluxos de trabalho com insights baseados em IA e automação inteligente.
            </SolutionDescription>
            <SolutionLink href="/solutions/operations">Saiba mais</SolutionLink>
          </SolutionCard>
          
          <SolutionCard>
            <SolutionIcon>🔒</SolutionIcon>
            <SolutionTitle>Segurança & TI</SolutionTitle>
            <SolutionDescription>
              Mantenha seus dados seguros com soluções de IA que priorizam segurança e conformidade.
            </SolutionDescription>
            <SolutionLink href="/solutions/security-it">Saiba mais</SolutionLink>
          </SolutionCard>
          
          <SolutionCard>
            <SolutionIcon>📝</SolutionIcon>
            <SolutionTitle>Gestão de Conteúdo</SolutionTitle>
            <SolutionDescription>
              Crie, gerencie e otimize conteúdo de suporte com ferramentas de IA avançadas.
            </SolutionDescription>
            <SolutionLink href="/solutions/content-management">Saiba mais</SolutionLink>
          </SolutionCard>
        </SolutionsGrid>
      </Section>

      {/* CX Teams Section */}
      <Section background="light">
        <FeatureBlock
          title="Equipes de CX"
          description="Transforme a experiência do cliente com IA que entende, resolve e aprimora cada interação."
          image={cxTeamsImage}
          imagePosition="right"
          features={[
            {
              title: "Resolução Automatizada",
              description: "Resolva problemas comuns de clientes sem intervenção humana."
            },
            {
              title: "Insights Acionáveis",
              description: "Obtenha insights valiosos sobre o comportamento e necessidades do cliente."
            },
            {
              title: "Experiência Personalizada",
              description: "Ofereça experiências personalizadas com base no histórico e contexto do cliente."
            }
          ]}
          actions={<Button>Saiba mais sobre Soluções para Equipes de CX</Button>}
        />
      </Section>

      {/* Support Agents Section */}
      <Section>
        <FeatureBlock
          title="Agentes de Suporte"
          description="Capacite seus agentes com ferramentas de IA que aumentam a produtividade e melhoram a satisfação do cliente."
          image={supportAgentsImage}
          imagePosition="left"
          features={[
            {
              title: "Copiloto de IA",
              description: "Assistente de IA em tempo real que fornece sugestões e informações relevantes."
            },
            {
              title: "Acesso Rápido ao Conhecimento",
              description: "Recupere informações da base de conhecimento instantaneamente durante interações."
            },
            {
              title: "Automação de Tarefas",
              description: "Automatize tarefas repetitivas para que os agentes possam focar em interações de valor."
            }
          ]}
          actions={<Button>Saiba mais sobre Soluções para Agentes de Suporte</Button>}
        />
      </Section>

      {/* Operations Section */}
      <Section background="light">
        <FeatureBlock
          title="Operações"
          description="Otimize processos e fluxos de trabalho com insights baseados em IA e automação inteligente."
          image={operationsImage}
          imagePosition="right"
          features={[
            {
              title: "Análise Preditiva",
              description: "Preveja volumes de tickets e aloque recursos de forma eficiente."
            },
            {
              title: "Otimização de Fluxos de Trabalho",
              description: "Identifique e elimine gargalos em seus processos de suporte."
            },
            {
              title: "Relatórios Avançados",
              description: "Obtenha insights detalhados sobre o desempenho da equipe e satisfação do cliente."
            }
          ]}
          actions={<Button>Saiba mais sobre Soluções para Operações</Button>}
        />
      </Section>

      {/* Solutions by Industry Section */}
      <Section>
        <SectionTitle>Soluções por Indústria</SectionTitle>
        <SectionDescription>
          A Leadfy entende os desafios únicos de cada indústria e oferece soluções personalizadas para atender às suas necessidades específicas.
        </SectionDescription>
        
        <IndustriesGrid>
          <IndustryCard>
            <IndustryIcon>💻</IndustryIcon>
            <IndustryTitle>SaaS</IndustryTitle>
            <IndustryDescription>
              Soluções de IA para empresas de software como serviço que buscam escalar o suporte ao cliente.
            </IndustryDescription>
            <IndustryLink href="/solutions/saas">Saiba mais</IndustryLink>
          </IndustryCard>
          
          <IndustryCard>
            <IndustryIcon>🛒</IndustryIcon>
            <IndustryTitle>Ecommerce & Varejo</IndustryTitle>
            <IndustryDescription>
              Melhore a experiência de compra e suporte pós-venda com IA personalizada.
            </IndustryDescription>
            <IndustryLink href="/solutions/ecommerce-retail">Saiba mais</IndustryLink>
          </IndustryCard>
          
          <IndustryCard>
            <IndustryIcon>💳</IndustryIcon>
            <IndustryTitle>Fintech</IndustryTitle>
            <IndustryDescription>
              Soluções seguras e conformes para empresas de tecnologia financeira.
            </IndustryDescription>
            <IndustryLink href="/solutions/fintech">Saiba mais</IndustryLink>
          </IndustryCard>
          
          <IndustryCard>
            <IndustryIcon>🏥</IndustryIcon>
            <IndustryTitle>Saúde</IndustryTitle>
            <IndustryDescription>
              Suporte ao paciente e gerenciamento de informações de saúde com IA segura e compatível com HIPAA.
            </IndustryDescription>
            <IndustryLink href="/solutions/healthcare">Saiba mais</IndustryLink>
          </IndustryCard>
          
          <IndustryCard>
            <IndustryIcon>📱</IndustryIcon>
            <IndustryTitle>Apps Móveis</IndustryTitle>
            <IndustryDescription>
              Suporte integrado para aplicativos móveis que melhora a retenção e satisfação do usuário.
            </IndustryDescription>
            <IndustryLink href="/solutions/mobile-apps">Saiba mais</IndustryLink>
          </IndustryCard>
        </IndustriesGrid>
      </Section>

      {/* Results Section */}
      <Section background="light">
        <SectionTitle>Resultados Comprovados</SectionTitle>
        <SectionDescription>
          Nossos clientes experimentam melhorias significativas em suas métricas de CX após implementar as soluções da Leadfy.
        </SectionDescription>
        
        <ResultsGrid>
          <ResultCard>
            <ResultValue>55%</ResultValue>
            <ResultLabel>Redução no tempo de resposta</ResultLabel>
          </ResultCard>
          
          <ResultCard>
            <ResultValue>65%</ResultValue>
            <ResultLabel>Taxa média de autoatendimento</ResultLabel>
          </ResultCard>
          
          <ResultCard>
            <ResultValue>40%</ResultValue>
            <ResultLabel>Aumento na satisfação do cliente</ResultLabel>
          </ResultCard>
          
          <ResultCard>
            <ResultValue>30%</ResultValue>
            <ResultLabel>Redução nos custos de suporte</ResultLabel>
          </ResultCard>
        </ResultsGrid>
      </Section>

      {/* CTA Section */}
      <Section>
        <SectionTitle>Descubra a Solução Ideal para Sua Empresa</SectionTitle>
        <SectionDescription>
          Entre em contato conosco para uma consulta personalizada e descubra como a Leadfy pode transformar sua experiência do cliente.
        </SectionDescription>
        
        <CenteredButton>
          <Button size="large">Solicite uma Demo</Button>
        </CenteredButton>
      </Section>
    </div>
  );
};

// Styled Components
const SolutionsHero = styled.section`
  background-color: var(--primary-dark);
  padding: var(--spacing-xxl) 0;
  color: var(--white);
`;

const SolutionsHeroContent = styled.div`
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
  padding: 0 var(--spacing-lg);
`;

const SolutionsHeroTitle = styled.h1`
  font-size: var(--font-size-4xl);
  margin-bottom: var(--spacing-lg);
`;

const SolutionsHeroSubtitle = styled.p`
  font-size: var(--font-size-xl);
  margin-bottom: var(--spacing-xl);
  opacity: 0.9;
`;

const SolutionsHeroActions = styled.div`
  display: flex;
  gap: var(--spacing-md);
  justify-content: center;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const Section = styled.section`
  padding: var(--spacing-xxl) 0;
  background-color: ${props => props.background === 'light' ? 'var(--light-bg)' : 'var(--white)'};
`;

const SectionTitle = styled.h2`
  font-size: var(--font-size-3xl);
  text-align: center;
  margin-bottom: var(--spacing-lg);
  color: var(--primary-dark);
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

const SectionDescription = styled.p`
  font-size: var(--font-size-lg);
  text-align: center;
  margin-bottom: var(--spacing-xl);
  color: var(--text-secondary);
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

const SolutionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--spacing-lg);
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--spacing-lg);
  
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const SolutionCard = styled.div`
  background-color: var(--white);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-md);
  padding: var(--spacing-lg);
  text-align: center;
  transition: transform var(--transition-normal), box-shadow var(--transition-normal);
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: var(--shadow-lg);
  }
`;

const SolutionIcon = styled.div`
  font-size: 3rem;
  margin-bottom: var(--spacing-md);
`;

const SolutionTitle = styled.h3`
  font-size: var(--font-size-xl);
  margin-bottom: var(--spacing-md);
  color: var(--primary-dark);
`;

const SolutionDescription = styled.p`
  font-size: var(--font-size-md);
  color: var(--text-secondary);
  margin-bottom: var(--spacing-lg);
`;

const SolutionLink = styled.a`
  color: var(--primary);
  font-weight: 600;
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`;

const IndustriesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--spacing-lg);
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--spacing-lg);
  
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const IndustryCard = styled.div`
  background-color: var(--white);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-md);
  padding: var(--spacing-lg);
  text-align: center;
  transition: transform var(--transition-normal), box-shadow var(--transition-normal);
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: var(--shadow-lg);
  }
`;

const IndustryIcon = styled.div`
  font-size: 3rem;
  margin-bottom: var(--spacing-md);
`;

const IndustryTitle = styled.h3`
  font-size: var(--font-size-xl);
  margin-bottom: var(--spacing-md);
  color: var(--primary-dark);
`;

const IndustryDescription = styled.p`
  font-size: var(--font-size-md);
  color: var(--text-secondary);
  margin-bottom: var(--spacing-lg);
`;

const IndustryLink = styled.a`
  color: var(--primary);
  font-weight: 600;
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`;

const ResultsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--spacing-lg);
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--spacing-lg);
  
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ResultCard = styled.div`
  background-color: var(--white);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-md);
  padding: var(--spacing-lg);
  text-align: center;
`;

const ResultValue = styled.div`
  font-size: var(--font-size-4xl);
  font-weight: 700;
  color: var(--primary);
  margin-bottom: var(--spacing-sm);
`;

const ResultLabel = styled.div`
  font-size: var(--font-size-md);
  color: var(--text-secondary);
`;

const CenteredButton = styled.div`
  display: flex;
  justify-content: center;
  margin-top: var(--spacing-xl);
`;

export default SolutionsPage;
